import React, { useEffect } from "react";

const DTOExpiredInsuranceViewModal = () => {
  return <></>;
};

export default DTOExpiredInsuranceViewModal;
